const apiPath = {
    master: {

        login: "master/login",

        get: {

            getdepartment: "master/getdepartment",
            getproduct: "master/getProductMas",
            getSubProductMas: "master/getSubProductMas",
            getDealerSmith: "master/getDealerSmith",
            getCounter: "master/getcounter",
            getItem: "master/getItem",
            getUOM: "master/getUOM",
            getRatemaster: "master/getRateMaster",
            getTagType: "master/getTagType",
            getHallMarkRate: "master/getHallMarkRate",
            getWasteTable: "master/getWasteTable",
            getPurchasedetail: "master/getPurchasedetail",
            getPurity: "master/getPurity",
            getProductHeadSP: "master/getProductHeadSP",
            getmetaltype: "master/getmetaltype",
            getproductlist: "master/getproductlist",
            getTagTypelist: "master/getTagTypelist",
            getsubproductlist: "master/getsubproductlist",
            getdealersmithlist: "master/getdealersmithlist",
            getsubproductlistall: "master/getsubproductlistall",
            getBranch:"master/getbranch",
            getFinYear:"master/getfinyear",
        },

        insert: {

            insertsubproduct: "master/insertsubproduct",
            insertDealersmith: "master/insertdealersmith",
            insertDepartment: "master/insertDepartment",
            uploadImg: "master/uploadeImg",
            insertRateMaster: "master/insertRateMaster",
            uploadeimg:"master/uploadeImg"
        },

        update: {
            updateDealersmith: "master/updatedealersmith",
            updatedepartment: "master/updateDepartment"
        },

        insertUpdate: {
            insertUpdateCounter: "master/insertUpdateCounter",
            insertUpdateProduct: "master/insertUpdateProduct",
            insertUpdateUOM: "master/insertUpdateUOM",
            insertUpdatePurity: "master/insertUpdatePurity",
            insertUpdateSubProduct: "master/insertUpdateSubProduct",
            insertUpdateTagType: "master/insertUpdateTagType",
            insertUpdateHallmark: "master/insertUpdateHallmark",
            insertUpdateWaste: "master/insertUpdateWaste",
            insertUpdateItem:"master/insertUpdateItem"
        },

        delete: {
            deleteaccmaster: "master/deleteaccmaster",
            deletedepmaster: "master/deletedepmaster"
        }



    }
}

export default apiPath;